(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["figderm-ritual"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function(event) {
  const radio = event.target.closest('[data-fd-bundle]');
  if (!radio) return;
  const form = radio.closest('form');
  form.querySelector('[data-fd-shipping]').textContent = radio.dataset.shipping;
  const button = form.querySelector('button[name="add"]');
  button.disabled = radio.dataset.available !== 'true';
  button.textContent = radio.dataset.available === 'true' ? radio.dataset.cta : 'Sold out';
  const url = new URL(window.location.href);
  url.searchParams.set('variant', radio.value);
  history.replaceState(null, '', url);
});
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-fd-image]');
  if (!button) return;
  const gallery = button.closest('.fd-gallery');
  const image = gallery.querySelector('.fd-main-image');
  image.removeAttribute('srcset');
  image.src = button.dataset.fdImage;
  image.alt = button.dataset.fdAlt;
  gallery.querySelectorAll('.fd-thumb').forEach(item => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
